export default ({ request }) => ({
  pendingGoodsReworkReportListApi(data = {}) {
    return request({
      url: '/factory/mrp/pending/goods/quality/reworkreport',
      method: 'post',
      data,
    })
  },
})
